/** Audit screen: who changed the system (rights, keys, knowledge, settings). */
export const audit = {
  'audit.title': 'Аудит',
  'audit.subtitle': 'Хто змінив систему: права, ключі, знання, налаштування. Що робили агенти — у Прогонах.',
  'audit.filter.actor': 'Будь-хто',
  'audit.filter.resourceType': 'Усі об’єкти',
  'audit.filter.from': 'З дати',
  'audit.filter.to': 'До дати',
  'audit.col.when': 'Коли',
  'audit.col.who': 'Хто',
  'audit.col.action': 'Дія',
  'audit.col.resource': 'Об’єкт',
  'audit.col.channel': 'Канал',
  'audit.col.change': 'Зміна',
  'audit.channel.panel': 'панель',
  'audit.channel.telegram': 'telegram',
  'audit.channel.api': 'api',
  'audit.channel.system': 'система',
  'audit.system': 'система',
  'audit.footer': 'Записи не редагуються і не видаляються (тригер у базі).',
  'audit.pagination.prev': 'Назад',
  'audit.pagination.next': 'Далі',
  'audit.pagination.page': 'Сторінка {page} з {pages}',
} as const;
